<template>
    <div>
        <div class="my-app">
            <Header :logo-src="require('@/assets/images/logo.png')" />
            <PageHeader page-title="Our Team" />
            <section class="section team-main pb-0">
                <div class="container">
                    <div class="row items-gap">
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="team-main-single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                <div class="thumb">
                                    <img :src="require('@/assets/images/teams/one.png')" alt="Image">
                                    <div class="social">
                                        <a href="https://www.facebook.com" aria-label="social media">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com" aria-label="social media">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com" aria-label="social media">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.instagram.com" aria-label="social media">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Robert V. Deguzman</h5>
                                        <p>Creative Developer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="team-main-single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                <div class="thumb">
                                    <img :src="require('@/assets/images/teams/two.png')" alt="Image">
                                    <div class="social">
                                        <a href="https://www.facebook.com" aria-label="social media">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com" aria-label="social media">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com" aria-label="social media">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.instagram.com" aria-label="social media">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Robert V. Deguzman</h5>
                                        <p>Creative Developer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="team-main-single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                <div class="thumb">
                                    <img :src="require('@/assets/images/teams/three.png')" alt="Image">
                                    <div class="social">
                                        <a href="https://www.facebook.com" aria-label="social media">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com" aria-label="social media">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com" aria-label="social media">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.instagram.com" aria-label="social media">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Robert V. Deguzman</h5>
                                        <p>Creative Developer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="team-main-single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                <div class="thumb">
                                    <img :src="require('@/assets/images/teams/four.png')" alt="Image">
                                    <div class="social">
                                        <a href="https://www.facebook.com" aria-label="social media">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com" aria-label="social media">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com" aria-label="social media">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.instagram.com" aria-label="social media">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Robert V. Deguzman</h5>
                                        <p>Creative Developer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="team-main-single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                <div class="thumb">
                                    <img :src="require('@/assets/images/teams/five.png')" alt="Image">
                                    <div class="social">
                                        <a href="https://www.facebook.com" aria-label="social media">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com" aria-label="social media">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com" aria-label="social media">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.instagram.com" aria-label="social media">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Robert V. Deguzman</h5>
                                        <p>Creative Developer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="team-main-single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                <div class="thumb">
                                    <img :src="require('@/assets/images/teams/six.png')" alt="Image">
                                    <div class="social">
                                        <a href="https://www.facebook.com" aria-label="social media">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com" aria-label="social media">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com" aria-label="social media">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.instagram.com" aria-label="social media">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Robert V. Deguzman</h5>
                                        <p>Creative Developer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <UpdateCTA />
            <Footer class="footer-light" />
        </div>
        <BackToTop />
    </div>
</template>

<script>
    import Header from '../components/layout/Header.vue'
    import PageHeader from '../components/layout/PageHeader.vue'
    import UpdateCTA from '../components/layout/UpdateCTA.vue'
    import Footer from '../components/layout/Footer.vue'
    import BackToTop from '../components/common/BackToTop.vue'
    export default {
        name: "UseCase",
        components: {
            Header,
            PageHeader,
            UpdateCTA,
            Footer,
            BackToTop
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/Teams.vue